/**
 * You can add new color using this file.
 * You can customized the colors for the entire Dashboard using this file.
 */

const colors = {
  primary: {
    main:  "#12948f",
    focus: "#2c3c58",
  },

  secondary: {
    main: "#6DC45E",
    focus: "#4f9d3e",
  },

  background: {
    default: "#f8f9fa",
  },

  text: {
    main: "#495057",
    focus: "#2c3c58",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  info: {
    main: '#3B82F6',
    focus: "#1d6fa5",
  },

  success: {
    main: '#4BB543',
    focus: "#3a9c3a",
  },

  warning: {
    main: '#F59E0B',
    focus: "#d99a0a",
  },

  error: {
    main: '#EF4444',
    focus: "#d32f2f",
  },

  light: {
    main: "#f8f9fa",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#495057",
    focus: "#343a40",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: 'linear-gradient(87deg, #5e72e4 0, #825ee4 100%)',
      state:  '#5e72e4',
    },

    secondary: {
      main: "#f5365c",
      state: "#f5365c",
    },

    info: {
      main: "#11cdef",
      state: "#11cdef",
    },

    success: {
      main: "#2dce89",
      state: "#2dce89",
    },

    warning: {
      main: "#fb8c00",
      state: "#fb8c00",
    },

    error: {
      main: "#f5365c",
      state: "#f5365c",
    },

    light: {
      main: "#adb5bd",
      state: "#adb5bd",
    },

    dark: {
      main: "#212529",
      state: "#212529",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#06AED4",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#1C2536",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#5e72e4",
    secondary: "#825ee4",
    info: "#11cdef",
    success: "#2dce89",
    warning: "#fb8c00",
    error: "#f5365c",
    light: "#adb5bd",
    dark: "#212529",
  },
  

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;

 